"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InterceptorChain = /** @class */ (function () {
    function InterceptorChain(next, interceptor) {
        this.interceptor = interceptor;
        this.next = next;
    }
    InterceptorChain.create = function (interceptors) {
        if (!interceptors) {
            interceptors = [];
        }
        var chain = InterceptorChain.END_OF_CHAIN;
        interceptors.reverse().forEach(function (interceptor) {
            chain = new InterceptorChain(chain, interceptor);
        });
        return chain;
    };
    InterceptorChain.prototype.proceed = function (methodContext) {
        if (this.isEndOfChain()) {
            return methodContext.executeTarget();
        }
        return this.interceptor.intercept(methodContext, this.next);
    };
    InterceptorChain.prototype.isEndOfChain = function () {
        return this === InterceptorChain.END_OF_CHAIN || !this.interceptor || !this.next;
    };
    InterceptorChain.END_OF_CHAIN = new InterceptorChain();
    return InterceptorChain;
}());
exports.default = InterceptorChain;
